import React from'react';

function Ticks(){
    return(
        <div className="ticks flex">
            <img src="/images/Group65.png" className="mr-10 first-tick ticks-size" alt="Money Back Guarantee" />
                <p className="ticks-p mb-0">Money back gurantee</p>                   
            <img src="/images/Group65.png" className="mr-10 second-tick ticks-size" alt="Cancel Anytime" />
                <p className="ticks-p mb-0">Cancel Anytime</p>
        </div>
    )
}

export default Ticks;